import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customization-options" }

import { computed } from 'vue';
import { spacingOptions as appSpacingOptions } from '@knack/style-engine';

import AppDesignPropertyPicker from '@/components/settings/design/AppDesignPropertyPicker';


const __default__ = {
  name: 'DesignOptionsTablesOptions',
};

type TablesOptionsProps = {
  customDesignObject?: Record<string, unknown>,
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    customDesignObject: null
  },
  setup(__props: any) {

const props = __props as {
  customDesignObject?: Record<string, unknown>,
};



const designPropertyBasePath = computed(() => {
  if (props.customDesignObject) {
    return '';
  }
  return 'general.tables.';
});

/**
 * Gather available spacing options from style-engine and match them to
 * our spacing icons in order. If future sizes are added we will need to add more
 * icons and possibly rename them so the order works.
 * @returns {Array}
 */
const spacingOptions = computed(() => {
  return appSpacingOptions.map((option: { label: string, value: string }, index: number) => ({
    ...option,
    icon: `table-density-${index + 1}`,
  }));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AppDesignPropertyPicker), {
      "custom-design-object": props.customDesignObject,
      "design-property": `${_unref(designPropertyBasePath)}style`,
      "label-text": "Format",
      options: ['clean', 'borders']
    }, null, 8, ["custom-design-object", "design-property"]),
    _createVNode(_unref(AppDesignPropertyPicker), {
      "custom-design-object": props.customDesignObject,
      "design-property": `${_unref(designPropertyBasePath)}striped`,
      "label-text": "Row Striping",
      "input-type": "checkbox",
      "description-text": "Use alternate background colors for grid rows"
    }, null, 8, ["custom-design-object", "design-property"]),
    _createVNode(_unref(AppDesignPropertyPicker), {
      "custom-design-object": props.customDesignObject,
      "design-property": `${_unref(designPropertyBasePath)}hover`,
      "label-text": "Row Hover",
      "input-type": "checkbox",
      "description-text": "Hovering over a row will highlight it"
    }, null, 8, ["custom-design-object", "design-property"]),
    _createVNode(_unref(AppDesignPropertyPicker), {
      "custom-design-object": props.customDesignObject,
      "design-property": `${_unref(designPropertyBasePath)}spacing`,
      "label-text": "Row Spacing",
      options: _unref(spacingOptions)
    }, null, 8, ["custom-design-object", "design-property", "options"])
  ]))
}
}

})